import { Backdrop, Box, LinearProgress } from '@mui/material';

function UploadingComponent({ open }: { open: boolean }) {
    if (!open) return <></>;
    return (
        <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={open}>
            <Box
                sx={{
                    width: '50%',
                    '& p': { fontSize: '28px', fontWeight: 700, textAlign: 'center' }
                }}
            >
                <p>Subiendo el documento...</p>
                <LinearProgress />
            </Box>
        </Backdrop>
    );
}

export default UploadingComponent;
